import CanalCobroShow from './CanalCobroShow'
export {CanalCobroShow}
export default CanalCobroShow
